import { render } from "./VerificationList.vue?vue&type=template&id=73f1211e&scoped=true&ts=true"
import script from "./VerificationList.vue?vue&type=script&lang=ts"
export * from "./VerificationList.vue?vue&type=script&lang=ts"

import "./VerificationList.vue?vue&type=style&index=0&id=73f1211e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f1211e"]])

export default __exports__